(() => {
  const fallbackLauncher = document.querySelector('.niu-chat-launcher');
  const stickyBar = document.querySelector('.product-sticky-cta, .mobile-discovery-bar');
  const isDiscoveryBar = Boolean(stickyBar?.matches('.mobile-discovery-bar'));
  const mobileViewport = window.matchMedia(isDiscoveryBar ? '(max-width: 767px)' : '(max-width: 749px)');
  const stickyChat = stickyBar?.querySelector('.product-sticky-chat, .mobile-discovery-bar__chat');
  let chatFrame;
  const syncDockedLauncher = () => {
    const available = Boolean(chatFrame && stickyChat);
    if (stickyChat) stickyChat.hidden = !available;
    document.body.classList.toggle('niu-chat-available', available);
    document.body.classList.toggle('niu-chat-docked', available && mobileViewport.matches && (isDiscoveryBar || stickyBar.classList.contains('is-visible')));
  };
  const syncChatState = () => {
    const bounds = chatFrame?.getBoundingClientRect();
    const open = Boolean(bounds && bounds.width > 200 && bounds.height > 200);
    document.body.classList.toggle('niu-chat-open', open);
    syncDockedLauncher();
  };
  const sizeObserver = new ResizeObserver(syncChatState);
  const attributeObserver = new MutationObserver(syncChatState);
  const syncNativeLauncher = () => {
    const frame = document.querySelector('#flyweight-chat iframe[title="Chat"]');
    if (fallbackLauncher) fallbackLauncher.hidden = Boolean(frame);
    if (frame === chatFrame) return;
    sizeObserver.disconnect();
    attributeObserver.disconnect();
    chatFrame = frame;
    if (chatFrame) {
      sizeObserver.observe(chatFrame);
      attributeObserver.observe(chatFrame, { attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
    }
    syncChatState();
  };
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element) || !event.target.closest('[data-flyweight-chat-trigger]')) return;
    event.preventDefault();
    window.dispatchEvent(new CustomEvent('flyweightchatopen', { detail: true }));
  });
  syncNativeLauncher();
  mobileViewport.addEventListener('change', syncDockedLauncher);
  if (stickyBar) new MutationObserver(syncDockedLauncher).observe(stickyBar, { attributes: true, attributeFilter: ['class'] });
  new MutationObserver(syncNativeLauncher).observe(document.body, { childList: true, subtree: true });
})();
